import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
//import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false;

Vue.use(Argon);

// Vue.use(VueAnalytics, {
// 	id: "UA-186737893-1",
// 	router,
// });

new Vue({
	router,
	render: (h) => h(App),
}).$mount("#app");
